import { IEmployment } from '@/context/borrower';

export function isEmploymentComplete(
    employment: IEmployment,
    isNovatedLease?: boolean
): boolean {
    const {
        occupation,
        employerPhone,
        employerName,
        years: employmentYears,
        months: employmentMonths,
    } = employment;

    if (!isNovatedLease && (occupation === null || occupation === undefined))
        return false;
    // The employer is free text now, so the answer is the name itself rather
    // than a lookup result — see EmployerLookup.
    if (!employerName?.trim()) return false;
    if (
        employerPhone === null ||
        employerPhone === undefined ||
        employerPhone.length < 10
    )
        return false;

    if (
        employmentYears === null ||
        (employmentYears === undefined &&
            (employmentMonths === null || employmentMonths === undefined))
    )
        return false;

    return true;
}
